function DocumentaryPreview(container) {
    this.container = container;
    this.previewElementWrapper = this.container.querySelector('.jsDocumentaryPreviewElements');
    this.buttons = this.container.querySelectorAll('.jsDocumentaryPreviewBtnWrapper button');
    this.videos = this.previewElementWrapper.querySelectorAll('.preview');
    this.playButton = this.previewElementWrapper.querySelector('.jsVideoPlayButton');
    this.nextSlideTime = 6000;
    this.nextSlideInterval = null;
    this.currentSlideIndex = 0;
    this.introSlideWrapper = this.container.querySelector('.jsHomeIntroSlideWrapper');
    this.introSlides = this.container.querySelectorAll('.jsHomeIntroSlide');
    this.timeIndicators = this.container.querySelectorAll('.jsTimeIndicator');
    this.gsapTimelines = [];

    setTimeout(_ => this.activatePreview(0), 3000);

    Array.prototype.forEach.call(this.buttons, btn => {
        btn.addEventListener('click', _ => this.activatePreview(parseInt(btn.dataset.index)));
    });

    if (! document.querySelector('html').classList.contains('touchevents')) {
        this.previewElementWrapper.querySelector('div').addEventListener('mousemove', e => {
            TweenLite.to(this.playButton, 0.5, { left: e.offsetX, top: e.offsetY, opacity: 1 });
        });

        this.previewElementWrapper.addEventListener('mouseout', _ => {
            TweenLite.to(this.playButton, 0.2, { opacity: 0 })
        });
    }

    this.setCountdown();
    setInterval(this.setCountdown.bind(this), 60 * 10);

    this.initPreviewTriggers();

    this.setSlideWrapperHeight();
    window.addEventListener('resize', this.setSlideWrapperHeight.bind(this));
};

DocumentaryPreview.prototype.setSlideWrapperHeight = function() {
    this.introSlideWrapper.style.height = '';
    let maxHeight = 0;

    for (let i = 0; i < this.introSlides.length; i++) {
        this.introSlides[i].style.display = 'block';

        const height = this.introSlides[i].offsetHeight;
        if (height > maxHeight) maxHeight = height;

        this.introSlides[i].style.display = '';
    }

    this.introSlideWrapper.style.height = maxHeight + 'px';
};

DocumentaryPreview.prototype.nextSlide = function() {
    if ((this.currentSlideIndex + 1) <= (this.videos.length - 1)) this.activatePreview(this.currentSlideIndex + 1);
    else this.activatePreview(0);
};

DocumentaryPreview.prototype.setTimeInterval = function() {
    if (this.nextSlideInterval) clearInterval(this.nextSlideInterval);
    this.nextSlideInterval = setInterval(this.nextSlide.bind(this), this.nextSlideTime);

    // Pause the current timelines
    for (let j = 0; j < this.gsapTimelines.length; j++) this.gsapTimelines[j].pause();
    this.gsapTimelines = [];

    // Activate the indicators and set others to 0 width
    for (let i = 0; i < this.timeIndicators.length; i++) {
        const slideIndex = parseInt(this.timeIndicators[i].parentElement.dataset.index);

        if (slideIndex === this.currentSlideIndex) {
            this.gsapTimelines.push(gsap.timeline()
                .set(this.timeIndicators[i], { width: 0 })
                .to(this.timeIndicators[i], this.nextSlideTime / 1000, { width: '100%', ease: Linear.easeNone }))
            ;
        }
        else {
            gsap.set(this.timeIndicators[i], { width: 0 });
        }
    }
};

DocumentaryPreview.prototype.activatePreview = function(index) {
    this.currentSlideIndex = index;
    this.setTimeInterval();

    for (let i = 0; i < this.videos.length; i++) {
        if (i === index) {
            if (this.buttons[i].dataset.type === 'video') {
                if (this.videos[i].classList.contains('not-available')) this.playButton.classList.add('not-available');
                else this.playButton.classList.remove('not-available');

                this.playButton.classList.remove('url');
            }
            else {
                this.playButton.classList.add('url');
                this.playButton.classList.remove('video-available');
                this.playButton.classList.remove('not-available');
                this.playButton.querySelector('.custom').innerHTML = this.buttons[i].dataset.titleOverlayBtn;
            }

            this.videos[i].classList.add('active');
            this.buttons[i].classList.add('active');
        }
        else {
            this.videos[i].classList.remove('active');
            this.buttons[i].classList.remove('active');
        }
    }

    // Set the active status
    for (let i = 0; i < this.introSlides.length; i++) {
        if (parseInt(this.introSlides[i].dataset.index) === index) this.introSlides[i].classList.add('active');
        else this.introSlides[i].classList.remove('active');
    }
}

DocumentaryPreview.prototype.setCountdown = function() {
    const availabilityDates = this.container.querySelectorAll('.jsPartAvailabilityDate');

    if (availabilityDates.length > 0) {
        Array.prototype.forEach.call(availabilityDates, el => {
            el.innerHTML = moment(el.dataset.date, "YYYYMMDD hh:mm").fromNow();
        });
    }
};

DocumentaryPreview.prototype.initPreviewTriggers = function() {
    const triggers = this.container.querySelectorAll('.jsPreviewTrigger');

    Array.prototype.forEach.call(triggers, trigger => {
        trigger.addEventListener('click', e => {
            e.preventDefault();
            new VideoModal(trigger.dataset.videoId);
        });
    });
};